export default {"src":"/_next/static/media/create_course.5561c320.svg","height":284,"width":284};